<div class="popup">
  <h1>Enrollment Status</h1>
  <p>
    Status:
    <span
      [ngClass]="{
        'success-message': data.status === 'Success',
        'failure-message': data.status !== 'Success',
      }"
      >{{
        data.status == 0
          ? "Enrollment
  Failed"
          : data.status
      }}</span
    >
  </p>
  @if (
    !data.enrollmentItemResponses || data.enrollmentItemResponses.length === 0
  ) {
    <p>Status Description: {{ data.statusDescription }}</p>
  }

  @for (item of data.enrollmentItemResponses; track item) {
    <div>
      <p>Enrollment Item: {{ item.enrollementItem }}</p>
      <!-- <p>Enrollment Item Type: {{item.enrollementItemType}}</p> -->
      <!-- <p>Enrollment Status: {{item.enrollmentStatus}}</p> -->
      <p>
        Enrollment Status Description: {{ item.enrollmentStatusDescription }}
      </p>
    </div>
  }
  <input type="button" class="p-button1" value="Close" (click)="close()" />
</div>
